let getSettings = () => {
    return {
        //api : "http://localhost:3001"
        api : "https://fitness-logger-one.herokuapp.com"
    }
}

export default getSettings()